import React from 'react';
import { Link } from 'react-router-dom';
import urls from '../../urls';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footerContainer">
        <div className="footerContent">
          <div className="footerLogo">
            <h3>PlotWyze</h3>
          </div>
          <div className="footerLinks">
            <a href="#contact">Contact</a>
            <a href="#support">Support</a>
            <Link to={urls.privacy}>Privacy</Link>
            <a href="#terms">Terms</a>
          </div>
        </div>
        <div className="footerCopyright">
          <p>&copy; {currentYear} PlotWyze. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
